module.exports = __webpack_public_path__ + "static/isaac-alferos-hero-image-small-de0890eea6ac3175fd5834b1af562775.jpg";